module.exports = __webpack_public_path__ + "img/free-dial.bf62a321.png";